export default __webpack_public_path__ + "static/media/intro.1c023e62.svg";